import { render, staticRenderFns } from "./ReceivableAdjustmentDetail.vue?vue&type=template&id=de2abea4&scoped=true&"
import script from "./ReceivableAdjustmentDetail.vue?vue&type=script&lang=js&"
export * from "./ReceivableAdjustmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2abea4",
  null
  
)

export default component.exports